export const YEAR = "year";                     // number (query)
export const MONTH = "month";                   // number (query)
export const GEO_REGION_ID = "geoRegionId";     // string (query)
export const SCHOOL_NAME = "schoolName";        // string (query)
export const CRM_RH = "crmRH";                  // string (query)
export const CRM_RM = "crmRM";                  // string (query)
export const INVOICE_OWNER = "invoiceOwner";    // string (query)
export const STATUS = "status";                 // string (query)
export const DUE_DAYS = "dueDays";              // number (query)
export const INVOICE_GENERATION_DATE = "invoiceGenerationDate"; // string (query)



export const invoicestatusOptions = [
  { label: "Overdue", value: "Overdue" },
  { label: "Unpaid", value: "UnPaid" },
  { label: "Partially Paid", value: "Partially_Paid" },
  { label: "Paid", value: "Paid" },
  { label: "Invoice Generated", value: "Invoice_generated" }
];
